import { getTimelineInterval } from "Areas/SharedFeatures/downSidePanel/redux/selectors";
import { connect } from "react-redux";
import { getClusteredPoints, getSelectedClusteredPoints } from "../redux/selectors";
import PointsCluster from "./pointsCluster";
const mapStateToProps = (state) => ({
    data: getClusteredPoints(state),
    selected: getSelectedClusteredPoints(state),
    timelineInterval: getTimelineInterval(state)
});
export default connect(mapStateToProps)(PointsCluster);
